import { jsx as _jsx } from "react/jsx-runtime";
import { MarketItemModalForm } from '../EntityModalForms/MarketItemModalForm';
function CreateMarketItemModal({ isOpen, onClose, onCreate, isLoading }) {
    return (_jsx(MarketItemModalForm, { isOpen: isOpen, onClose: onClose, onSubmit: onCreate, isLoading: isLoading, mode: "create", item: null, title: "Create Market Item", submitIdleLabel: "Create", submitBusyLabel: "Creating..." }));
}
export default CreateMarketItemModal;
